/* This file is autogenerated, see readme.md for instructions */
import CloseSvgIcon from '@bloomreach/banana-theme/icons/close.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CloseIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CloseSvgIcon />
    </Icon>
  );
});

CloseIcon.displayName = 'CloseIcon';

export default CloseIcon;
